import { render } from "./TransactionStatus9.vue?vue&type=template&id=70636a2e&scoped=true&ts=true"
import script from "./TransactionStatus9.vue?vue&type=script&lang=ts"
export * from "./TransactionStatus9.vue?vue&type=script&lang=ts"

import "./TransactionStatus9.vue?vue&type=style&index=0&id=70636a2e&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70636a2e"]])

export default __exports__